import { GamePage } from "./GamePage.js";
import { Lobby } from "./Lobby.js";
import { UsernameGate } from "./UsernameGate.js";
import { gameIdFromPath, navigate, useRoute } from "./router.js";
import { useSession } from "./useSession.js";

export function App() {
  const { state, signIn, signOut } = useSession();
  const path = useRoute();
  const gameId = gameIdFromPath(path);

  if (state.status === "loading") {
    return (
      <main className="shell shell--center">
        <p className="muted">Loading…</p>
      </main>
    );
  }

  // Signing in keeps the current path, so following an invite link and then
  // picking a name drops you straight into that game.
  if (state.status === "anonymous") {
    return (
      <main className="shell shell--center">
        <UsernameGate onSubmit={signIn} />
      </main>
    );
  }

  return (
    <main className="shell">
      <header className="topbar">
        <button type="button" className="topbar__home" onClick={() => navigate("/")}>
          Chess
        </button>
        <div className="topbar__user">
          <span className="muted">
            Signed in as <strong>{state.user.username}</strong>
          </span>
          <button type="button" className="button--secondary" onClick={() => void signOut()}>
            Sign out
          </button>
        </div>
      </header>

      {gameId ? <GamePage gameId={gameId} user={state.user} /> : <Lobby user={state.user} />}
    </main>
  );
}
